import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher } from '../../../../../../common/field-validation/my-error-state-matcher';
import { isDefined, isNotEmpty } from '../../../../../utils/utils';

interface OddsDTO {
  type: string;
  value: number;
}

@Component({
  selector: 'app-form-field-odds',
  templateUrl: './odds-form-field.component.html',
  styleUrls: ['./odds-form-field.component.scss'],
  standalone: false,
})
export class OddsFormFieldComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  matcher = new MyErrorStateMatcher();

  options: string[];

  displayOddsType: string = '';

  displayOddsValue: string = '';

  previousInternalFormGroupValue: any;

  internalFormGroup: UntypedFormGroup;

  editReadOnly: boolean;

  numberOfDecimalPlaces = 5;

  showType: boolean = true;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder
  ) {
    super();
  }

  ngOnDestroy() {}

  ngOnInit(): void {
    if (isNotEmpty(this.fieldConfig.properties)) {
      try {
        const properties = JSON.parse(this.fieldConfig.properties);
        if (isDefined(properties.showOddsType)) {
          this.showType = properties.showOddsType;
        }
      } catch (err) {
        console.log('error converting to json', this.fieldConfig.properties);
      }
    }

    this.options = this.fieldConfig.options;
    if (this.formGroup) {
      const formControl = this.formGroup.get(this.fieldConfig.name);
      formControl.valueChanges.subscribe((d) => {
        if (!this.areEqual(d, this.data)) {
          this.initialize(d);
        }
      });
      // const data = this.formGroup.getRawValue();
      this.editReadOnly = this.formGroup.get(this.fieldConfig.name).disabled;
    }
    this.initialize(this.formGroup ? this.formGroup.get(this.fieldConfig.name).value : this.data);
  }

  private areEqual(a: OddsDTO, b: OddsDTO): boolean {
    if ((a && !b) || (!a && b) || (!a.type && b.type) || (a.type && !b.type)) {
      return false;
    }
    return a.type === b.type && a.value === b.value;
  }

  private initialize(d: OddsDTO) {
    this.data = d;
    if (!this.data) {
      this.data = {
        type: null,
        value: null,
      };
    }

    if (this.data) {
      this.displayOddsValue = this.data.value; // this.formatValue(this.data);
      this.displayOddsType = this.data.type;
      this.changeDetectorRef.detectChanges();
    }

    this.internalFormGroup = this.formBuilder.group({
      type: this.data.type,
      value: this.data.value ? `0${String(Math.abs(this.data.value % 100))}`.slice(-2) : null,
    });
    this.previousInternalFormGroupValue = this.internalFormGroup.getRawValue();

    this.internalFormGroup.valueChanges.subscribe((odds: OddsDTO) => {
      this.setParentFormError();
      this.numberOfDecimalPlaces = this.getNumberOfDecimalPlaces(odds);

      const oddsValue = Math.abs(Number(odds.value ? odds.value : 0) * 10 ** this.numberOfDecimalPlaces);

      if (Number.isNaN(oddsValue)) {
        return;
      }

      const value: OddsDTO = {
        type: odds.type,
        value: oddsValue,
      };
      this.data = value;
      this.formGroup.get(this.fieldConfig.name).setValue(value);
      this.previousInternalFormGroupValue = this.internalFormGroup.getRawValue();

      const numPlaces = this.countDecimals(odds);
      if (numPlaces > this.numberOfDecimalPlaces) {
        this.formGroup.get(this.fieldConfig.name).setErrors({ incorrect: true });
        this.internalFormGroup.get('value').setErrors({ incorrect: true });
      } else {
        this.internalFormGroup.get('value').setErrors(null);
        this.formGroup.get(this.fieldConfig.name).setErrors(null);
      }
    });
  }

  private setParentFormError() {
    this.formGroup.get(this.fieldConfig.name).setErrors({ incorrect: true });
  }

  private countDecimals(odds: OddsDTO): number {
    if (!odds.value) {
      return 0;
    }
    if (odds.value % 1 != 0) {
      return odds.value.toString().split(this.whatDecimalSeparator())[1].length;
    }
    return 0;
  }

  private whatDecimalSeparator(): string {
    const n = 1.1;
    return /^1(.+)1$/.exec(n.toLocaleString())[1];
  }

  private getNumberOfDecimalPlaces(odds: OddsDTO): number {
    if (isDefined(odds) && isDefined(odds.type)) {
      if (odds.type === 'US') {
        return 0;
      }
      if (odds.type === 'D') {
        return 5;
      }
      if (odds.type === 'P') {
        return 5;
      }
      if (odds.type === 'HK') {
        return 5;
      }
      if (odds.type === 'M') {
        return 5;
      }
      if (odds.type === 'I') {
        return 0;
      }
    } else {
      return 0;
    }
  }
}
